import type { ReactNode } from 'react'
import { HelmetProvider } from 'react-helmet-async'

export const withHelmet = (component: () => ReactNode) => () => (
  <HelmetProvider>
    {component()}
  </HelmetProvider>
)
